module.exports = __webpack_public_path__ + "img/u665.395e13f5.jpg";